import { Injectable, EventEmitter } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { UntypedFormArray } from '@angular/forms';
import * as _ from 'lodash';

@Injectable()
export class TableEditableService {

  rows: any[] = [];
  selectedRows: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]); // { row, index }
  isEditing: boolean = false;

  get selectedRowsValue(): any {
    return this.selectedRows.getValue();
  }

  public init(rows: any[]) {
    this.rows = rows;
  }

  public selectRow(row: any): void {
    const rows = this.selectedRows.getValue();
    rows.push({row, index: _.findIndex(this.rows, row)});
    this.selectedRows.next(rows);
  }

  public unselectRow(row: any): void {
    const rows = this.selectedRows.getValue();
    _.remove(rows, (item: any) => item.row === row);
    this.selectedRows.next(rows);
  }

  public removeSelectedRows(formArray?: UntypedFormArray): void {
    if (formArray) {
      _.each(this.selectedRowsValue, (item: any) => {
        const index = formArray.controls.indexOf(item.row);
        formArray.removeAt(index);
      });
    } else {
      _.remove(this.rows, (row: any, index: number) => {
        return _.some(this.selectedRowsValue, (item: any) => item.row === row);
      });
    }
    this.selectedRows.next([]);
  }

  public reset(): void {
    this.rows = [];
    this.selectedRows.next([]);
    this.selectedRows.complete();
  }
}
